import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import baseTheme, { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";

import Typography from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    height = "height",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.height]: string;
    };
}

export interface FooterBottomStyles {
    copyright?: InjectableCss;
    privacyPolicy?: InjectableCss;
    socialiconWrap?: InjectableCss;
    wrapperStyles?: InjectableCss;
}

export const footerBottomStyles: FooterBottomStyles = {
    wrapperStyles: {
        css: css`
            background: linear-gradient(268deg, #44a8f7 0%, #0b70b7 100%);
            height: ${fields.height}px;
            width: 100%;
            align-items: center;
            display: flex;
            justify-content: space-between;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        height: auto;
                        padding: 15px 8px 0 8px;
                    `,
                    css`
                        height: auto;
                        padding: 15px;
                    `,
                    css`
                        height: auto;
                        padding: 15px;
                    `,
                    css`
                        max-width: 100%;
                        ${GridItemStyle} {
                            padding: 0 25px;
                        }
                    `,
                    css`
                        max-width: 100%;
                        ${GridItemStyle} {
                            padding: 0 25px;
                        }
                    `,
                ])},
        `,
    },
    privacyPolicy: {
        css: css`
            margin-left: 5px;
            &:hover{
                text-decoration: underline;
            }
        `,
    },
    copyright: {
        css: css`
            color: #fff;
            font-size: 13px;
            display: flex;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        justify-content: center;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        justify-content: center;
                    `,
                    css`
                        flex-basis: 80%;
                        max-width: 80%;
                        margin-top: 15px;
                        padding-top: 15px !important;
                        padding-left: 50px !important;
                    `,
                    css`
                        flex-basis: 80%;
                        max-width: 80%;
                        margin-top: 15px;
                        padding-top: 15px !important;
                        padding-left: 50px !important;
                    `,
                    css`
                        flex-basis: 80%;
                        max-width: 80%;
                        margin-top: 15px;
                        padding-top: 15px !important;
                        padding-left: 50px !important;
                    `,
                ])},
            a {
                span {
                    color: #fff !important;
                }
            }
        `,
    },
    socialiconWrap: {
        css: css`
            align-items: center;
            display: flex;
            flex-direction: row;
            justify-content: center;
            text-align: center;
            ${({ theme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        height: 50px;
                    `,
                    css`
                        flex-basis: 100%;
                        max-width: 100%;
                        height: 50px;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                    css`
                        flex-basis: 20%;
                        max-width: 20%;
                    `,
                ])};
        `,
    },
};

type Props = WidgetProps;

const FooterBottom: React.FC<Props> = ({ fields, id }) => {
    const styles = footerBottomStyles;

    return (
        <StyledWrapper>
            <GridContainer {...styles.wrapperStyles} gap={0}>
                <GridItem {...styles.copyright}>
                    <StyledWrapper>
                        {/* <Typography as="p">{siteMessage("Copyright © 2021 KGPCo. All Rights Reserved. | ")}</Typography> */}
                        <Zone zoneName="zoneOne" contentId={id} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.privacyPolicy}>
                        <Zone zoneName="zoneTwo" contentId={id} />
                    </StyledWrapper>
                    <StyledWrapper {...styles.privacyPolicy}>
                        <Zone zoneName="zoneThree" contentId={id} />
                    </StyledWrapper>
                </GridItem>
                <GridItem {...styles.socialiconWrap} width={12}>
                    <GridItem width={[2, 2, 2, 1, 1]}>
                        <Zone zoneName="a" contentId={id} />
                    </GridItem>
                    <GridItem width={[2, 2, 2, 1, 1]}>
                        <Zone zoneName="b" contentId={id} />
                    </GridItem>
                    <GridItem width={[2, 2, 2, 1, 1]}>
                        <Zone zoneName="c" contentId={id} />
                    </GridItem>
                </GridItem>
            </GridContainer>
        </StyledWrapper>
    );
};

const basicTab = {
    displayName: "Basic",
    sortOrder: 0,
};

const footerBottom: WidgetModule = {
    component: FooterBottom,
    definition: {
        group: "Footer",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.height,
                editorTemplate: "IntegerField",
                defaultValue: 49,
                displayName: "Container Height",
                tab: basicTab,
            },
        ],
    },
};

export default footerBottom;
